module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAASFBMVEUAAAD////b29vZ2dnY2NjY2NjY2Njf39/a2trZ2dnY2Njb29va2trY2NjZ2dnY2NjZ2dnd3d3v7+/19fXb29v////4+PjY2NjBYdISAAAAGHRSTlMABkeVv9nzGJbx/weC9Mcu4y3///////KwFRwWAAAAsUlEQVR4AYWTBQLDMAhFiXtd7n/S+diY9L960QSgF0ob67x31mhF34SYMpNiIEmpLQtaLcK8y190b076If9gGNn+S/7QePgowr+Ics+j5r/UW4D2X6Fdg8R8QCRSvD/TvNxflnniHVOkWXtet5vGsq0z/9Rk+H3ZLhr8eGDIZqkh5dmSy1JDyrMjn6WGlGePFHYYAiYJl4k3Cm41LBYuN2wY3HKwaXHb48FBoweGF4z/GYoHJJ4tT4H5AAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/change-icon/e2_delete@2x.png
// module id = y9By
// module chunks = 0